var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.alternative)?_c('img',{staticClass:"x-img",attrs:{"src":require("@/assets/presentation_1.jpeg")}}):_c('img',{staticClass:"x-img",attrs:{"src":require("@/assets/presentation_2.jpeg")}})}
var staticRenderFns = []

export { render, staticRenderFns }